
import {  
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { UploadButton } from "../../../utils/Custom/Button";
import { toast } from "react-toastify";
import { BASE_URL } from "../../../global";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import React from "react";

export const FileUploadComponent = ({
  fileUploadResponse = "",
  setFileUploadResponse,
  label,
}) => {
  const [open, setOpen] = React.useState(false);

  const files = fileUploadResponse
    ? fileUploadResponse.split(",")
    : [];

  const handleFileUpload = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (!selectedFiles.length) return;
    // Temporary URL for testing (will be replaced with actual upload)
    // const tempUrl = "https://DYC Global.bfiinfotech.co.in/api/fileUpload/uploads/1766488710__LIMS%20%202%20Plans.pdf";
    

    const uploadedUrls = [];

    for (const file of selectedFiles) {
      // Comment out the actual upload code
      // uploadedUrls.push(tempUrl);      
      const data = new FormData();
      data.append("fileToUpload", file);
      try {
        const res = await axiosWithToken.post(BASE_URL + "fileUpload/fileUpload.php", data);
        if (res.status === 200) {
          uploadedUrls.push(res.data);
        }
      } catch (err) {
        console.error(err);
      }
    }

    const existing = fileUploadResponse
      ? fileUploadResponse.split(",")
      : [];

    setFileUploadResponse([...existing, ...uploadedUrls].join(","));
    toast.success("Files uploaded successfully!");
  };

  const handleRemoveFile = (index) => {
    const updated = [...files];
    updated.splice(index, 1);
    setFileUploadResponse(updated.join(","));
  };

  return (
    <div>
    <div className="flex items-center gap-3">
      {/* View Button */}
      {files.length > 0 && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="text-blue-600 underline text-sm"
          style={{ minWidth: "fit-content" }}
        >
          View ({files.length})
        </button>
      )}

      {/* Upload Button */}
    <div className="flex flex-col flex-grow">
      <UploadButton
        label={label}
        onChange={handleFileUpload}
        multiple
        className="w-full"
        // className="!py-1 !px-2"
      />
          <span className="text-xs text-gray-500 mt-1 whitespace-nowrap">
            • Max file size: 5 MB per file
            <br/>• Max 5 files allowed
          </span>
        </div>
      </div>
      
      {/* Modal */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle className="flex justify-between items-center">
          Uploaded Files
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {files.length === 0 ? (
            <p className="text-sm text-gray-500">No files uploaded</p>
          ) : (
            <div className="flex flex-col gap-2">
              {files.map((url, index) => {
                const fileName = decodeURIComponent(
                  url.split("__").pop()
                );

                return (
                  <div
                    key={index}
                    className="flex items-center justify-between border rounded px-3 py-2 text-sm"
                  >
                    <span className="truncate max-w-[250px]">
                      {fileName}
                    </span>

                    <div className="flex items-center gap-2">
                      <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 text-sm font-medium"
                      >
                        View
                      </a>

                      <span className="text-gray-300">|</span>

                      <button
                        type="button"
                        onClick={() => handleRemoveFile(index)}
                        className="inline-flex items-center gap-1 text-red-500 hover:text-red-700 text-sm font-medium"
                      >
                        Remove
                      </button>
                    </div>

                  </div>
                );
              })}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};